module.exports = __webpack_public_path__ + "static/media/3.60ba1719.jpg";